import { getAppSafeTopArea, isPc } from '@/utils/utils';
import { Button, DatePicker, Modal, Toast ,Popup,ButtonProps} from 'antd-mobile';


import { DateRangePickMobile } from '../Filter/DateRangePick/DateRangePickMobile';
import React from 'react';
import ReactDOM from 'react-dom';
import './filterMobile.less';
import styled from 'styled-components';
import { DatePickMobile, DatePickMobileProps } from './DatePick/DatePickMobile';
import {
  FilterAccountStatusprops,
  FilterClientAreaProps,
  FilterClientTypeProps,
  FilterCollaboratorProps,
  FilterCommonInnerProps,
  FilterDatePickProps,
  FilterGoodsBrandProps,
  FilterInputProps,
  FilterSelectProps,
  FilterSelectWarehouseTypeProps,
  FilterStaffBranchProps,
  FilterStaffProps,
  RangePick,
  FilterGoodsTagsPcprops,
  FilterTagsprops,
  FilterSelectWarehouseProps,
  FilterSelectGoodsProps,
  FilterPutAwayProps,
  FilterGoodsTypeProps,
  FilterGoodsCategoryProps,
  FilterCommonProps,
  FilterTypes,
  FilterProps,
} from '../FilterCommon/Filter';
import { FilterClientAreaMobile, FilterClientAreaMobileProps } from './FilterClientArea/FilterClientAreaMobile';
import { FilterClientTypeMobile, FilterClientTypeMobileProps } from './FilterClientType/FilterClientTypeMobile';
import { FilterStaffMobile, FilterStaffMobileProps } from './FilterStaff/FilterStaffMobile';
import { FilterGoodsMobile, FilterGoodsMobileProps } from './FilterGoods/FilterGoodsMobile';
import {  FilterFilterCommonSearchConditionMobile,FilterCommonSearchConditionPropsMobile } from './Common/FilterCommonSearchCondition'
import { FilterGoodsTagAndBrandMobile } from './FilterGoodsTagAndBrand/FilterGoodsTagAndBrandMobile'
import { LabelItem } from './Common/LabelItem';
import { FilterDeliverType } from './FilterDeliverType/FilterDeliverType';
import { useNavigate, useSearchParams} from 'react-router-dom'
export type FilterAllMobile =
  | FilterClientAreaProps
  // | RangePick
  // | FilterStaffProps
  // | FilterSelectProps
  // | FilterInputProps
  // | FilterStaffBranchProps
  | FilterDatePickProps
  | FilterClientTypeProps
  // | FilterGoodsCategoryProps
  // | FilterGoodsBrandProps
  // | FilterGoodsTypeProps
  // | FilterPutAwayProps
  // | FilterSelectGoodsProps
  // | FilterSelectWarehouseTypeProps
  // | FilterCollaboratorProps
  // | FilterSelectWarehouseProps
  // | FilterTagsprops
  // | FilterGoodsTagsPcprops
  // | FilterAccountStatusprops


export interface FilterListMobileProps  extends FilterProps {
  // filters: FilterAllMobile[];
  // onChangeValues(dataIndex: string, value: any,source?: any): void;
  // values?: any;
}
  
export interface FilterMobileProps  extends Omit<FilterCommonProps,'type'>  {
  // filters: FilterAllMobile[];
  onChangeValues(dataIndex: string, value: any,source?: any): void;
  placeholder?:string
  value?: any;
}
  
const PopupView = styled(Popup)`
  .adm-popup-body-position-right{
    width: 90%;
    display: flex;
    flex-direction: column;
  }
  .filter-mobile{
    flex: 1;
    background-color: #fff;
  }
`
// interface FilterMobileProps extends Omit<FilterCommonProps,'type'> {
//   onChangeValues: (dataIndex: string, value: any, source?: any) => void;
// }

export const FilterComponents:Partial<Record<FilterTypes,React.FC<any>>> = {
 [FilterTypes.DatePick]:(props:FilterMobileProps & DatePickMobileProps )=>{
    const { dataIndex,onChangeValues, ...rest } = props

    return <DatePickMobile
      {...rest}
      onChange={(date,DataString)=>{
        props.onChange && props.onChange(date,DataString);
        onChangeValues(dataIndex, DataString,{date,DataString});
      }}
    />
  },
  [FilterTypes.ClientArea]:(props:FilterMobileProps & FilterClientAreaMobileProps )=>{
    const { dataIndex,onChangeValues, ...rest } = props
    return <FilterClientAreaMobile
      { ...rest }
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
    
    />
  },
  [FilterTypes.ClientType]:(props:FilterMobileProps & FilterClientTypeMobileProps )=>{
    const { dataIndex,onChangeValues, ...rest } = props
    return <FilterClientTypeMobile
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
    
    />
  },
  [FilterTypes.Staff]:(props:FilterMobileProps & FilterStaffMobileProps )=>{
    const { dataIndex,onChangeValues, ...rest } = props
    return <FilterStaffMobile
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
    
    />
  },
  [FilterTypes.SelectGoods]:(props:FilterMobileProps & FilterGoodsMobileProps )=>{
    const { dataIndex,onChangeValues, ...rest } = props
    return <FilterGoodsMobile
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
    
    />
  },
  [FilterTypes.AccountStatus]:(props:FilterMobileProps)=>{
    const { dataIndex,onChangeValues, placeholder = '账号状态', ...rest } = props
    return <FilterFilterCommonSearchConditionMobile
      placeholder={placeholder}
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
      searchCondition={{client:["new_status"]}}
      getSearchConditionValue={(searchCondition)=>  {
        return  searchCondition.client?.new_status || []
      }} 
      
    />
  },
  [FilterTypes.GoodsCategory]:(props:FilterMobileProps  )=>{
    const { dataIndex,onChangeValues, placeholder = '商品分类', ...rest } = props
    return <FilterFilterCommonSearchConditionMobile
      placeholder={placeholder}
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
      searchCondition={{goods:["category"]}}
      addAllChildren
      getSearchConditionValue={(searchCondition)=>  {
        return  searchCondition.goods?.category || []
      }} 
      
    />
  },
  [FilterTypes.GoodsType]:(props:FilterMobileProps  )=>{
    const { dataIndex,onChangeValues, placeholder = '商品标识', ...rest } = props
    return <FilterFilterCommonSearchConditionMobile
      placeholder={placeholder}
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
      searchCondition={{goods:["goods_type"]}}
      getSearchConditionValue={(searchCondition)=>  {
        return  searchCondition.goods?.goods_type || []
      }} 
      
    />
  },
  [FilterTypes.SelectWarehouse]:(props:FilterMobileProps  )=>{
    const { dataIndex,onChangeValues, placeholder = '全部仓库', ...rest } = props
    return <FilterFilterCommonSearchConditionMobile
      placeholder={placeholder}
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
      searchCondition={{purchase:["stock"]}}
      getSearchConditionValue={(searchCondition)=>  {
        return  searchCondition.purchase?.stock || []
      }} 
    />
  },
  [FilterTypes.SelectWarehouseType]:(props:FilterMobileProps  )=>{
    const { dataIndex,onChangeValues, placeholder = '仓库类型', ...rest } = props
    return <FilterFilterCommonSearchConditionMobile
      placeholder={placeholder}
      {...rest}
      onChange={(value)=>{
        onChangeValues(dataIndex,value)
      }}
      searchCondition={{stock:["in_type",'out_type']}}
      getSearchConditionValue={(searchCondition)=>  {
        return  [...searchCondition.stock?.in_type || [], ...searchCondition.stock?.out_type || []]
      }} 
    />
  },
  [FilterTypes.PutAway]:(props:FilterMobileProps  )=>{
    const { dataIndex,onChangeValues,  placeholder = '上下架', ...rest } = props
    return <div>
      <LabelItem
        {...rest }
        options={[{label:'上架',value:'T'},{label:'下架',value:'F'}]}
        label={placeholder}
        multiple
        columns={2}
        arrow={false}
        optionPostion='bottom'
        onChange={(value)=>{
          onChangeValues(dataIndex,value)
        }}
      />
    </div>
  },
  [FilterTypes.GoodsTags]:(props:FilterMobileProps  )=>{
    const { dataIndex, onChangeValues,  placeholder = '商品标签', ...rest } = props
    return <FilterGoodsTagAndBrandMobile
        type='tag'
        {...rest }
        placeholder={placeholder}
        onChange={(value)=>{
          onChangeValues(dataIndex,value)
        }}
      />
  },
  [FilterTypes.GoodsBrand]:(props:FilterMobileProps  )=>{
    const { dataIndex, onChangeValues,  placeholder = '商品品牌', ...rest } = props
    return <FilterGoodsTagAndBrandMobile
        type='brand'
        {...rest }
        placeholder={placeholder}
        onChange={(value)=>{
          onChangeValues(dataIndex,value)
        }}
      />
  },
  [FilterTypes.DeliverType]:(props:FilterMobileProps  )=>{
    const { dataIndex, onChangeValues,  placeholder = '配送方式', ...rest } = props
    return <FilterDeliverType
        {...rest }
        placeholder={placeholder}
        onChange={(value)=>{
          onChangeValues(dataIndex,value)
        }}
      />
  },
}

// export const FilterComponents: { [x in FilterAllMobile['type']]?: React.FC<any> } = {
//   // ClientArea: FilterClientAreaMobile,
//   // RangePick: DateRangePickMobile,
//   // DatePick: (props:FilterDatePickProps & FilterCommonInnerProps)=>{
//   //   const { dataIndex,onChangeValues,...rest } = props
//   //   return <DatePickMobile
//   //     {...rest}
    
//   //   />
//   // },
// }





const FilterListMobile = (props: FilterListMobileProps) => {
  // const platform: Platform = 'mobile';
  // let [container,setContainer] = React.useState<HTMLElement>();
  // const [number,setNumber] = React.useState(0)
  // React.useEffect(()=>{
  //   let container = document.createElement('div')
  //   document.querySelector('.adm-picker-header')?.after(container)
  //   setContainer(container)
  //   setTimeout(()=>{
  //     setNumber(2)
  //   },5000)
  // },[])
  // let test = ()=>{
  //   return container && ReactDOM.createPortal(<div>123aa{number}</div>,container)
  // }
  const {  values } = props
  let paddingTop = getAppSafeTopArea()
  return (
    <div className='filter-mobile'
      style={{paddingTop: paddingTop}}
    >
      {props.filters.map((item, index) => {
        let {   type, ...rest } = item;
        let Component = FilterComponents[item.type] as  React.FC<any>;
        if (!Component) {
          console.error(`${type} not find`);
          return null;
        }
        let value = values[item.dataIndex]
        return (
          <div key={index}>
            <Component  value={value} onChangeValues={props.onChangeValues} { ...rest} />
          </div>
        );
      })}
    </div>
  );
};


interface DhbFilterMobileProps<FP> {
  onrest?: (params: FP) => void;
  params?:FP
  onSearch(params: FP): void;
  defaultParams?: FP;
  filterProps: Pick<FilterListMobileProps, 'filters'>;
  loading?: boolean;
}

export const DhbFilterMobile = <FP extends {}>(props: DhbFilterMobileProps<FP>) => {
  let defaultParams = { ...props.defaultParams } as FP;
  const { filterProps  } = props
  const [visible, setVisible] = React.useState(false);
  const [params, setParams] = React.useState<FP>({ ...defaultParams });
  const navigate = useNavigate()
  const [searchParams,setSearchPartams] = useSearchParams()

  const onrest = () => {
    setParams({ ...defaultParams });
    props.onrest && props.onrest({ ...defaultParams });
  };
  const onSearch = () => {
    // Object.keys
    // setVisible(false)
    navigate(-1)
    props.onSearch({...params});
  };
  const onClose = ()=>{
    navigate(-1)
    // setVisible(false)
  }
  React.useEffect(()=>{
    if(props.params){
      setParams(props.params)
    }
  },[props.params])
  let showFilter = searchParams.get('showFilter')  == '1'
  React.useEffect(()=>{
    setVisible(showFilter)
  },[showFilter])

  const onChangeValues = (dataIndex:string,value:any,source:any)=>{
    setParams(params=>{
      return {...params,[dataIndex]:value}
    })
  }
  return (
    <div>
      {/* <span onClick={() => setVisible(true)}>筛选</span> */}
      <span onClick={() =>
        navigate(`${window.location.pathname}?showFilter=1`)
      }>筛选</span>
      <PopupView
        // popup
        // closable
        position='right'
        className="filter-wrap-modal"
        closeOnMaskClick
        visible={visible}
        onClose={onClose}
      >
        <FilterListMobile {...filterProps} values={params}  onChangeValues={onChangeValues}/>
        <PopupFooter actions={[{text:'重置',onClick:onrest,  },{text:'确定',onClick:onSearch,color:'primary'}]} />
      </PopupView>
    </div>
  );
};


const PopupFooterView = styled.div`
  display: flex;
  .btn{
    flex: 1;
    margin: 10px;
  }
`


interface PoupFooter{
  actions:Array<{text:React.ReactNode} & ButtonProps>


}


const PopupFooter:React.FC<PoupFooter> = (props)=>{
  return <PopupFooterView>
    { props.actions.map((item,index)=>{
      const {text, ...buttonProps} = item
      return <Button className='btn' key={index} {...buttonProps}>{text}</Button>
    }) }
  </PopupFooterView>
}
